import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...girdiler) {
    return twMerge(clsx(girdiler));
}
//# sourceMappingURL=cn.js.map